// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3jdT-","rootCenter":"LoadMoreObserver_rootCenter__2kujT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__mF1Y7"};